export function getUrlQueryString(obj: Record<string, any>) {
  let result = '';
  const keys = Object.keys(obj);

  keys.forEach((key, i) => {
    const value = obj[key];
    const and = i === 0 ? '' : '&';

    result += `${and}${key}=${value}`;
  });

  return result;
}

export function convertZeroNumber(number: number) {
  return number < 10 ? `0${number}` : `${number}`;
}

export function dateToStr(date: Date) {
  const year = String(date.getFullYear());
  const month = convertZeroNumber(date.getMonth() + 1);
  const day = convertZeroNumber(date.getDate());
  const hour = convertZeroNumber(date.getHours());
  const min = convertZeroNumber(date.getMinutes());
  const sec = convertZeroNumber(date.getSeconds());

  return `${year}${month}${day}${hour}${min}${sec}`;
}

export function convertDateTime(date: Date) {
  const year = date.getFullYear();
  const month = convertZeroNumber(date.getMonth() + 1);
  const day = convertZeroNumber(date.getDate());
  const hours = convertZeroNumber(date.getHours());
  const minutes = convertZeroNumber(date.getMinutes());
  const seconds = convertZeroNumber(date.getSeconds());

  return {
    date: `${year}-${month}-${day}`,
    time: `${hours}:${minutes}:${seconds}`,
  };
}

export function convertDetailTime(targetSeconds: number) {
  const seconds = targetSeconds % 60;
  const minutes = ((targetSeconds - seconds) / 60) % 60;
  const hours = (targetSeconds - minutes * 60 - seconds) / (60 * 60);

  return {
    seconds,
    minutes,
    hours,
  };
}

export function checkImage(url: string):Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img.naturalWidth > 0);
    img.onerror = () => resolve(false);
    img.src = url
  });
}